import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from './environment.service';
import { RemoteConfig } from '../models/remote-config';
import { forkJoin, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class RemoteConfigService {

    private _remoteConfig: RemoteConfig;

    get remoteConfig(): RemoteConfig {
        return this._remoteConfig;
    }

    constructor(private http: HttpClient,
                private env: EnvironmentService) {

    }

    getConfig(): Observable<RemoteConfig> {
        return this.http.get<RemoteConfig>(`${this.env.contentCdnHost}/v1/remoteconfig`);
    }

    getTheme(): Observable<string> {
        return this.http.get(`${this.env.contentCdnHost}/v1/remoteconfig/css`, {responseType: 'text'});
    }

    init(): Promise<any> {
        return forkJoin([
                this.getConfig().pipe(tap(config => {
                    this._remoteConfig = config;
                    this._remoteConfig.livestream_enabled = true;
                })),
                this.getTheme().pipe(tap(cssVariables => {
                    const headTag = document.getElementsByTagName('head')[0];
                    const styleTag = document.createElement('style');

                    styleTag.innerHTML = `:root {${cssVariables}}`;
                    headTag.appendChild(styleTag);
                }))
            ]).toPromise();
    }
}
